// card payments (Moneris) are plan-level: settings entries flagged RequiresCardPayments (drawer items, dashboard
// tiles) show only where the portal setting hasCardPayments is true (#4647). The payment service also refuses
// portals it does not allow, so this is the display switch, not the only gate.
export const forCardPayments = (items, hasCardPayments) =>
  items?.filter((i) => !i.RequiresCardPayments || hasCardPayments);

// loads Moneris's widget script once per URL (it differs between the test and production gateways)
const loaded = {};
export const loadMonerisScript = (src) => {
  if (!loaded[src]) {
    loaded[src] = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = () => {
        delete loaded[src];
        reject(new Error(`could not load ${src}`));
      };
      document.head.appendChild(s);
    });
  }
  return loaded[src];
};
